/** Hosted references are not owned video files. Never send these URLs to file processing. */
export type YouTubeReference = {
  videoId: string;
  watchUrl: string;
  embedUrl: string;
  thumbnailUrl: string;
};

const VIDEO_ID = /^[A-Za-z0-9_-]{11}$/;
const VIDEO_HOSTS = new Set(["youtube.com", "www.youtube.com", "m.youtube.com", "music.youtube.com"]);
const EMBED_HOSTS = new Set(["youtube-nocookie.com", "www.youtube-nocookie.com"]);

export function parseYouTubeUrl(raw?: string | null): YouTubeReference | null {
  if (typeof raw !== "string" || raw.length > 2048) return null;
  try {
    const url = new URL(raw.trim());
    if (!["https:", "http:"].includes(url.protocol) || url.username || url.password || url.port) return null;
    let videoId: string | undefined;
    if (url.hostname === "youtu.be" || url.hostname === "www.youtu.be") {
      const match = url.pathname.match(/^\/([A-Za-z0-9_-]{11})\/?$/);
      videoId = match?.[1];
    } else if (VIDEO_HOSTS.has(url.hostname)) {
      if (/^\/watch\/?$/.test(url.pathname) && url.searchParams.getAll("v").length === 1) {
        videoId = url.searchParams.get("v") ?? undefined;
      } else {
        videoId = url.pathname.match(/^\/(?:shorts|embed|live)\/([A-Za-z0-9_-]{11})\/?$/)?.[1];
      }
    } else if (EMBED_HOSTS.has(url.hostname)) {
      videoId = url.pathname.match(/^\/embed\/([A-Za-z0-9_-]{11})\/?$/)?.[1];
    }
    if (!videoId || !VIDEO_ID.test(videoId)) return null;
    return {
      videoId,
      watchUrl: `https://www.youtube.com/watch?v=${videoId}`,
      embedUrl: `https://www.youtube-nocookie.com/embed/${videoId}`,
      thumbnailUrl: `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
    };
  } catch {
    return null;
  }
}

export function isYouTubeUrl(raw?: string | null): boolean {
  return parseYouTubeUrl(raw) !== null;
}